import { SHOW_COMMEMORATE } from 'src/constants';
import { SOCIAL_LIST } from 'src/constants/layout';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const WidgetFollow = ({ eventDataLayer }: any) => {
  return (
    <>
      <WidgetWrapper id='widget-follow' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
        {SOCIAL_LIST.map((item: any, index: any) => (
          <a
            tabIndex={-1}
            target='_blank'
            key={index}
            href={item?.link}
            rel='noopener nopopopener nofollow'
            aria-label={`ติดตาม ${item?.name}`}
            title={`ติดตาม ${item?.name}`}
            //! DATALAYER
            onClick={() =>
              sendDataLayerGlobal({
                ...eventDataLayer,
                data: {
                  title: item?.name,
                  heading: item?.name,
                  index: index + 1
                }
              })
            }
          >
            <div className={`bg-item --${item.name || 'default'}`}>{item.icon}</div>
          </a>
        ))}
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  a {
    margin-left: 15px;
  }
  a:first-child {
    margin-left: 0px;
  }
  .bg-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    &.--default {
      background-color: rgba(0, 0, 0);
      border: 1px solid #fff;
    }
    &.--facebook {
      background-color: #ed1a3b;
      border: 1px solid #fff;
    }
    &.--X {
      background-color: #ed1a3b;
      border: 1px solid #fff;
    }
    &.--instagram {
      background: #ed1a3b;
      border: 1px solid #fff;
    }
    &.--youtube {
      background-color: #ed1a3b;
      border: 1px solid #fff;
    }
    @media (max-width: 1024px) {
      width: 42px;
      height: 42px;
    }
    svg {
      color: rgba(255, 255, 255, 1);
    }
    &:hover {
      background-color: #ed1a3b;
      svg {
        color: rgba(255, 255, 255);
      }
    }
  }
`;
export default WidgetFollow;
